// @ts-nocheck
import useAccessibleSubmit from "@insite/client-framework/Common/Hooks/useAccessibleSubmit";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import siteMessage from "@insite/client-framework/SiteMessage";
import { OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import translate from "@insite/client-framework/Translate";
import { OrderLineModel } from "@insite/client-framework/Types/ApiModels";
import CardContainer, { CardContainerStyles } from "@insite/content-library/Components/CardContainer";
import ProductBrand, { ProductBrandStyles } from "@insite/content-library/Components/ProductBrand";
import { StyledButton } from "@insite/mobius/Clickable";
import DataTable, { DataTablePresentationProps } from "@insite/mobius/DataTable";
import { DataTableCellProps } from "@insite/mobius/DataTable/DataTableCell";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import { DataTableBody, DataTableCell, DataTableHead, DataTableHeader, DataTableRow } from "@insite/mobius/index";
import LazyImage, { LazyImageProps } from "@insite/mobius/LazyImage";
import Link from "@insite/mobius/Link";
import TextField, { TextFieldPresentationProps } from "@insite/mobius/TextField";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import Button, { ButtonProps } from "@store/MobiusOverrides/Button/Button";
import Checkbox from "@store/MobiusOverrides/Checkbox/Checkbox";
import { LinkPresentationProps } from "@store/MobiusOverrides/Link/Link";
import Modal from "@store/MobiusOverrides/Modal/Modal";
import Typography, { TypographyProps } from "@store/MobiusOverrides/Typography/Typography";
import setNewOrderLines from "@store/Framework/Store/Greif/Pages/OrderComplaint/Handlers/SetNewOrderLines";
import setQuantityNonConformancies from "@store/Framework/Store/Greif/Pages/OrderComplaint/Handlers/SetNewQtyNonConformacies";
import ProductDescription, { ProductDescriptionStyles } from "@store/Overrides/Components/ProductDescription";
import ProductPartNumbers, { ProductPartNumbersStyles } from "@store/Overrides/Components/ProductPartNumbers";
import { productLineProps } from "@store/Themes/common/props/productLine";
import breakpointValues from "@toolkit/Framework/Common/Utilities/breakpointValues";
import mergeProps from "@toolkit/Framework/Common/Utilities/mergeProps";
import { pxToRem, pxToRemArray } from "@toolkit/Framework/Common/Utilities/unitHelper";
import React, { FC, useContext } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

interface OwnProps {
    clearProducts: boolean;
}

const mapDispatchToProps = {
    setNewOrderLines,
    setQuantityNonConformancies,
};

type Props = OwnProps & ResolveThunks<typeof mapDispatchToProps>;

export interface RequestOrderComplaintProductListStyles {
    gridContainer?: GridContainerProps;
    wrapper?: InjectableCss;
    infoTitleText?: TypographyProps;
    infoMessageText?: TypographyProps;
    addProductButton?: ButtonProps;
    filteredItemWrapper?: InjectableCss;
    filteredItemText?: InjectableCss;
    orderLineCardContainer?: CardContainerStyles;
    orderLineQtyCardContainer?: CardContainerStyles;
    orderLineCardGridContainer?: GridContainerProps;
    orderLineCardImageGridItem?: GridItemProps;
    orderLineCardImage?: LazyImageProps;
    orderLineCardInfoGridItem?: GridItemProps;
    orderLineCardQtyNonConformanciesGridItem?: GridItemProps;
    orderLineCardInfoGridContainer?: GridContainerProps;
    orderLineCardCheckboxGridItem?: GridItemProps;
    productInfoGridItem?: GridItemProps;
    productInfoGridContainer?: GridContainerProps;
    productInfoBrandDescriptionGridItem?: GridItemProps;
    productInfoBrandDescriptionGridContainer?: GridContainerProps;
    productInfoBrandGridItem?: GridItemProps;
    productInfoDescriptionGridItem?: GridItemProps;
    productDescriptionStyles?: ProductDescriptionStyles;
    productBrandStyles?: ProductBrandStyles;
    productInfoPartNumbersGridItem?: GridItemProps;
    productPartNumbers?: ProductPartNumbersStyles;
    orderLineInfoGridItem?: GridItemProps;
    orderLineInfoGridContainer?: GridContainerProps;
    orderLinePriceGridItem?: GridItemProps;
    productInfoQtyOrderedGridItem?: GridItemProps;
    productInfoSubtotalGridItem?: GridItemProps;
    removeProduct?: LinkPresentationProps;
    modalDoneButtonGridItem?: GridItemProps;
    modalDoneButton?: ButtonProps;
    selectedProductsTable?: DataTablePresentationProps;
    productNameCell?: DataTableCellProps;
    requiredField?: TypographyPresentationProps;
    qtyOrderendText?: TypographyPresentationProps;
    editableQuantityTextField?: TextFieldPresentationProps;
}

export const requestOrderComplaintProductListStyles: RequestOrderComplaintProductListStyles = {
    wrapper: {
        css: css`
            background-color: ${getColor("common.accent")};
            height: 100%;
            width: 100%;
            ${breakpointValues([pxToRem(16), null, pxToRem(32), null, null], "padding")}
        `,
    },
    addProductButton: {
        css: css`
            ${x => x.theme.button.primary.css}
            margin-top: ${pxToRem(20)};
        `,
    },
    orderLineCardImageGridItem: {
        width: [3, 3, 2, 2, 1],
        printWidth: 1,
        css: css`
            padding-left: 0;
        `,
    },
    orderLineCardInfoGridItem: {
        width: [6, 6, 7, 7, 8],
    },
    orderLineCardQtyNonConformanciesGridItem: {
        width: [6, 6, 7, 7, 8],
        css: css`
            align-items: center;
            justify-content: end;
        `,
    },
    orderLineCardInfoGridContainer: {
        gap: 10,
    },
    productInfoGridItem: {
        width: [12, 12, 8, 8, 8],
    },
    productInfoGridContainer: {
        gap: 5,
    },
    productInfoBrandDescriptionGridItem: { width: 12 },
    productInfoBrandDescriptionGridContainer: { gap: 5 },
    productInfoBrandGridItem: { width: 12 },
    productInfoDescriptionGridItem: { width: 12 },
    productInfoPartNumbersGridItem: {
        width: 12,
        css: css`
            flex-direction: column;
        `,
    },
    productPartNumbers: {
        erpNumberLabelText: {
            css: css`
                margin-right: ${pxToRem(8)};
            `,
        },
        customerNameLabelText: {
            css: css`
                margin-right: ${pxToRem(8)};
            `,
        },
        manufacturerItemLabelText: {
            css: css`
                margin-right: ${pxToRem(8)};
            `,
        },
    },
    orderLineInfoGridItem: {
        width: [12, 12, 4, 4, 4],
        printWidth: 6,
    },
    orderLineInfoGridContainer: { gap: 10 },
    orderLinePriceGridItem: {
        width: [12, 12, 12, 12, 7],
        printWidth: 7,
    },
    productInfoQtyOrderedGridItem: {
        width: [12, 12, 12, 12, 5],
        printWidth: 5,
    },
    productInfoSubtotalGridItem: { width: 12 },
    infoTitleText: {
        variant: "h5",
        as: "h3",
    },
    infoMessageText: {
        as: "p",
        css: css`
            font-size: ${x => x.theme.design.typography.size.small};
        `,
    },
    filteredItemWrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            margin-top: ${pxToRem(20)};
        `,
    },
    orderLineCardContainer: {
        gridItem: {
            css: css`
                & > div:first-of-type {
                    border-top: none;
                }
            `,
        },
    },
    orderLineQtyCardContainer: {
        gridItem: {
            css: css`
                & > div:first-of-type {
                    border-top: none;
                }
                padding-top: 0 !important;
            `,
        },
    },
    orderLineCardGridContainer: {
        css: css`
            & > div:first-of-type {
                justify-content: center;
            }
        `,
    },
    selectedProductsTable: {
        css: css`
            ${x => x.theme.dataTable.defaultProps?.css}
            border: ${pxToRem(2)} solid ${getColor("text")};
        `,
    },
    productNameCell: {
        css: css`
            > ${StyledButton}, > ${TypographyStyle}, > [class*="ProductNumber"] {
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                display: block;

                ${breakpointValues(pxToRemArray([170, 380, 500, 260, 360]), "max-width")}
            }
        `,
    },
    filteredItemText: {
        css: css`
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
        `,
    },
    removeProduct: mergeProps<LinkPresentationProps>(productLineProps.removeLink, {
        typographyProps: {
            css: css`
                ${breakpointValues(["none", "block", null, null, null], "display")};
            `,
        },
    }),
    modalDoneButtonGridItem: {
        width: 12,
        css: css`
            ${breakpointValues([null, null, "end", null, null], "justify-content", "up")}
        `,
    },
    modalDoneButton: {
        css: css`
            ${x => x.theme.button.primary.css}
            ${breakpointValues(["100%", null, "20%", null, null], "width", "up")}
        `,
    },
    requiredField: {
        color: "danger.main",
    },
    qtyOrderendText: {
        size: "0.875rem",
        weight: "bold",
    },
    editableQuantityTextField: { ...productLineProps.quantity?.editableQuantityTextField },
};

const ProductInfo = ({ orderLine }: { orderLine: OrderLineModel }) => {
    return (
        <GridItem {...styles.productInfoGridItem}>
            <GridContainer {...styles.productInfoGridContainer}>
                <GridItem {...styles.productInfoBrandDescriptionGridItem}>
                    <GridContainer {...styles.productInfoBrandDescriptionGridContainer}>
                        {orderLine.brand && (
                            <GridItem {...styles.productInfoBrandGridItem}>
                                <ProductBrand brand={orderLine.brand} extendedStyles={styles.productBrandStyles} />
                            </GridItem>
                        )}
                        <GridItem {...styles.productInfoDescriptionGridItem}>
                            <ProductDescription
                                product={orderLine}
                                extendedStyles={styles.productDescriptionStyles}
                                noLink
                            />
                        </GridItem>
                    </GridContainer>
                </GridItem>
                <GridItem {...styles.productInfoPartNumbersGridItem}>
                    <ProductPartNumbers
                        productNumber={orderLine.productErpNumber}
                        customerProductNumber={orderLine.customerProductNumber}
                        manufacturerItem={orderLine.manufacturerItem}
                        extendedStyles={styles.productPartNumbers}
                        showLineNumber
                        cartLineNumber={orderLine.lineNumber}
                    />
                </GridItem>
                <GridItem {...styles.productInfoPartNumbersGridItem}>
                    <Typography {...styles.qtyOrderendText}>{`${translate("{0}:", translate("QTY Ordered"))} ${
                        orderLine.qtyOrdered
                    }`}</Typography>
                </GridItem>
            </GridContainer>
        </GridItem>
    );
};

const OrderLineCard = (props: {
    orderLine: OrderLineModel;
    setProductComplaint: any;
    isCheck: boolean;
    disabled: boolean;
}) => {
    const { orderLine, setProductComplaint, isCheck, disabled } = props;
    const [isChecked, setIsChecked] = React.useState(isCheck);

    const handleCheckProduct = () => {
        if (isChecked) {
            setProductComplaint(null);
        } else if (!isChecked) {
            setProductComplaint(orderLine);
        }
        setIsChecked(!isChecked);
    };

    return (
        <GridContainer {...styles.orderLineCardGridContainer}>
            <GridItem {...styles.orderLineCardImageGridItem}>
                {orderLine.productUri && orderLine.isActiveProduct && (
                    <Link href={orderLine.productUri}>
                        <LazyImage {...styles.orderLineCardImage} src={orderLine.mediumImagePath} />
                    </Link>
                )}
            </GridItem>
            <GridItem {...styles.orderLineCardInfoGridItem}>
                <GridContainer {...styles.orderLineCardInfoGridContainer}>
                    <ProductInfo orderLine={orderLine} />
                </GridContainer>
            </GridItem>
            <GridItem {...styles.orderLineCardCheckboxGridItem}>
                <Checkbox disabled={disabled} checked={isChecked} onChange={handleCheckProduct} />
            </GridItem>
        </GridContainer>
    );
};

const styles = requestOrderComplaintProductListStyles;

const RequestOrderComplaintProductList: FC<Props> = ({
    setNewOrderLines,
    setQuantityNonConformancies,
    clearProducts,
}) => {
    const [isProductComplaintModalOpen, setIsProductComplaintModalOpen] = React.useState(false);
    const [filteredOrder, setFilteredOrder] = React.useState<OrderLineModel | null>(null);
    const [qtyNonConformancies, setQtyNonConformancies] = React.useState<string>("");
    const { value: order } = useContext(OrderStateContext);
    const orderLines = order?.orderLines;
    const { value, changeHandler, keyDownHandler, blurHandler } = useAccessibleSubmit(qtyNonConformancies, value =>
        setQtyNonConformancies(value),
    );

    React.useEffect(() => {
        if (clearProducts) {
            setFilteredOrder(null);
            setQtyNonConformancies("");
        }
    }, [clearProducts]);

    React.useEffect(() => {
        if (!order || !order.orderLines) {
            return;
        }

        setNewOrderLines({ orderLine: filteredOrder });
    }, [filteredOrder]);

    React.useEffect(() => {
        if (!qtyNonConformancies) {
            return;
        }

        setQuantityNonConformancies({ qtyNonConformancies: parseInt(qtyNonConformancies, 10) });
    }, [qtyNonConformancies]);

    if (!order || !order.orderLines) {
        return null;
    }

    const closeProductComplaintModal = (e: any) => {
        e.preventDefault();
        setIsProductComplaintModalOpen(false);
    };
    const openProductComplaintModal = (e: any) => {
        e.preventDefault();
        setIsProductComplaintModalOpen(true);
    };

    const removeProductHandler = () => {
        setFilteredOrder(null);
        setQtyNonConformancies("");
    };

    return (
        <StyledWrapper {...styles.wrapper}>
            <Typography {...styles.infoTitleText}>
                {translate("Products")}
                <Typography {...styles.requiredField}> *</Typography>
            </Typography>
            <Typography {...styles.infoMessageText}>{siteMessage("OrderComplaint_ProductSelect")}</Typography>
            {!!filteredOrder && (
                <StyledWrapper {...styles.filteredItemWrapper}>
                    <DataTable {...styles.selectedProductsTable}>
                        <DataTableHead>
                            <DataTableHeader>{translate("Product")}</DataTableHeader>
                            <DataTableHeader>{translate("Qty Non-Conformancies")}</DataTableHeader>
                            <DataTableHeader>{translate("Action")}</DataTableHeader>
                        </DataTableHead>
                        <DataTableBody>
                            <DataTableRow key={filteredOrder.id}>
                                <DataTableCell {...styles.productNameCell}>
                                    <ProductDescription
                                        product={filteredOrder}
                                        extendedStyles={styles.productDescriptionStyles}
                                        noLink
                                    />
                                    <ProductPartNumbers
                                        productNumber={filteredOrder.productErpNumber}
                                        customerProductNumber={filteredOrder.customerProductNumber}
                                        manufacturerItem={filteredOrder.manufacturerItem}
                                        extendedStyles={styles.productPartNumbers}
                                        showLineNumber
                                        cartLineNumber={filteredOrder.lineNumber} // Calculation x10 is done in the component, needs to divide before passing the info
                                    />
                                    <Typography
                                        {...styles.qtyOrderendText}
                                    >{`${translate("{0}:", translate("QTY Ordered"))} ${
                                        filteredOrder.qtyOrdered
                                    }`}</Typography>
                                </DataTableCell>
                                <DataTableCell>
                                    <TextField
                                        {...styles.editableQuantityTextField}
                                        type="number"
                                        min={0}
                                        max={filteredOrder.qtyOrdered}
                                        value={value}
                                        onChange={changeHandler}
                                        onKeyDown={keyDownHandler}
                                        onBlur={blurHandler}
                                        onClick={event => event.currentTarget.focus()}
                                    />
                                </DataTableCell>
                                <DataTableCell>
                                    <Link {...styles.removeProduct} onClick={() => removeProductHandler()}>
                                        {translate("Remove")}
                                    </Link>
                                </DataTableCell>
                            </DataTableRow>
                        </DataTableBody>
                    </DataTable>
                </StyledWrapper>
            )}
            <Button {...styles.addProductButton} onClick={openProductComplaintModal}>
                {translate("Select product(s)")}
            </Button>
            <Modal
                size={800}
                headline={translate("Select Product For Complaint")}
                isOpen={isProductComplaintModalOpen}
                handleClose={closeProductComplaintModal}
            >
                <GridContainer {...styles.gridContainer} data-test-selector="requestOrderComplaintProductList">
                    {orderLines?.map(orderLine => (
                        <CardContainer extendedStyles={styles.orderLineCardContainer} key={orderLine.id}>
                            <OrderLineCard
                                orderLine={orderLine}
                                setProductComplaint={setFilteredOrder}
                                isCheck={filteredOrder?.id === orderLine.id}
                                disabled={!!filteredOrder && filteredOrder?.id !== orderLine.id}
                            />
                        </CardContainer>
                    ))}
                    {!!filteredOrder && (
                        <CardContainer extendedStyles={styles.orderLineQtyCardContainer} key="qtyNonConformancies">
                            <GridContainer {...styles.orderLineCardGridContainer}>
                                <GridItem {...styles.orderLineCardImageGridItem} />
                                <GridItem {...styles.orderLineCardQtyNonConformanciesGridItem}>
                                    <Typography {...styles.qtyOrderendText}>{`${translate(
                                        "{0}:",
                                        translate("Qty Non-Conformancies"),
                                    )}`}</Typography>
                                </GridItem>
                                <GridItem {...styles.orderLineCardCheckboxGridItem}>
                                    <TextField
                                        {...styles.editableQuantityTextField}
                                        type="number"
                                        min={0}
                                        max={filteredOrder.qtyOrdered}
                                        value={value}
                                        onChange={changeHandler}
                                        onKeyDown={keyDownHandler}
                                        onBlur={blurHandler}
                                        onClick={event => event.currentTarget.focus()}
                                    />
                                </GridItem>
                            </GridContainer>
                        </CardContainer>
                    )}
                    <GridItem {...styles.modalDoneButtonGridItem}>
                        <Button {...styles.modalDoneButton} onClick={closeProductComplaintModal}>
                            {translate("Done")}
                        </Button>
                    </GridItem>
                </GridContainer>
            </Modal>
        </StyledWrapper>
    );
};

export default connect(null, mapDispatchToProps)(RequestOrderComplaintProductList);
